document.addEventListener('DOMContentLoaded', function() {
    // Elements
    const dialog = document.getElementById('credit-limit-dialog');
    const checkoutButton = document.getElementById('checkout');
    const closeDialogBtn = document.getElementById('close-dialog');
    const closeDialogXBtn = document.getElementById('close-dialog-x');
    const useCreditLimitBtn = document.getElementById('use-credit-limit');
    const useNormalCheckoutBtn = document.getElementById('use-normal-checkout');
    const overlay = document.querySelector('#credit-limit-dialog .dialog-overlay');
    const checkbox = document.getElementById("rterms-1");
   
    
      

    checkoutButton.addEventListener('click', function(event) {
    
       

       if(customer_status=="enable"){
          event.preventDefault(); 
         if(checkbox.checked){
           dialog.style.display = 'block'; 
         }
          
      }
      
    });

   
  
   
    closeDialogXBtn.addEventListener('click', function() {
        dialog.style.display = 'none'
    });

  
    overlay.addEventListener('click', function() {
        dialog.style.display = 'none'; 
    });

      
     function updateCartAttribute(attributeKey, attributeValue) {
        const data = {
            attributes: {}
        };
        
        // Set the custom attribute key and value
        data.attributes[attributeKey] = attributeValue;

        // AJAX request to update the cart
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(cart => {

        //after updating the cart check for the credit limit


          

        })
        .catch(error => {
            console.error('Error updating cart attribute:', error);
        });
    }
    
    useCreditLimitBtn.addEventListener('click', function() {

  
      

       fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                

            
              // var selling_plan_description = cart.items[0].selling_plan_allocation.selling_plan.description;

              // console.log(selling_plan_description);



                 const cartTotal = cart.total_price / 100; // Shopify API returns price in cents
                if (cartTotal > remaininglimit) {
                    alert(`Your cart total is $${cartTotal}, which exceeds your remaining credit limit of $${remaininglimit}. Please reduce the cart total or use normal checkout`);
                } else {
                    // Proceed with checkout using credit limit
                  window.location.href = "/checkout";
                    // You can add logic to take the user to a custom credit-limit checkout flow here
                }


              //updateCartAttribute("selling_plan_description",selling_plan_description);

             
            })
            .catch(error => {
                console.error('Error fetching cart data:', error);
            });
      
    });

   
    useNormalCheckoutBtn.addEventListener('click', function() {
   
     
   
     fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let variantString = '';
                cart.items.forEach(item => {
                    variantString += `${item.variant_id}:${item.quantity},`;
                });
                variantString = variantString.slice(0, -1); // Remove last comma

                const shopUrl = window.location.hostname;
                const checkoutUrl = `cart/${variantString}`;
                console.log(checkoutUrl);
                // Redirect to custom checkout link
               window.location.href = checkoutUrl;
            })
            .catch(error => {
                console.error('Error fetching cart data:', error);
            });
    });
});